import axios from 'axios';

export class RequestsAbort {
  constructor() {
    this.abortControllers = new Map();
  }

  abort(name) {
    this.abortControllers.get(name)?.abort();
  }

  register(name) {
    const abortController = new AbortController();

    this.abortControllers.set(name, abortController);

    return abortController;
  }

  static isAborted(error) {
    return axios.isCancel(error);
  }
}

export default RequestsAbort;
